import './style.scss'
import { NavLink, useNavigate, useLocation } from "react-router-dom"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AppSpan, CustomContainer, FlexRow } from "src/style"
import { menuOptions } from './menu-options'
import * as device from 'react-device-detect'
import { useContext, useEffect, useState } from 'react'
import { Dropdown } from 'src/component'
import { UserType } from 'src/model'
import { IoIosArrowDown } from "react-icons/io";

export const Menu: React.FC<any> = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const {info} = useContext(AppInfoContext)
    const [userType, setUserType] = useState('')

    useEffect(() => {
        if (info.userType) setUserType(info.userType)
    }, [info.userType, location])

    function handleMenuOption (route: string) {
        navigate(route)
    }

    return (
        <FlexRow 
            gap='1' justifyContent='flex-start' 
            style={{minWidth: 'fit-content'}}
        >
            {
                menuOptions?.map((item, index) => {
                    return (
                        item.userType === userType &&
                            <CustomContainer
                                width='auto' sizeUnit='' key={index}
                            >
                                { (['Users'].includes(item.title) && userType === UserType.ADMIN) || (['API management'].includes(item.title) && userType === UserType.PARTNER) ?
                                     <Dropdown
                                        trigger={
                                            <div
                                                className={`default-menu ${location?.pathname.includes(item?.basePath!) && 'active-menu'}`}
                                            >
                                                <AppSpan 
                                                    color='#ffffff' textSize='1.6' 
                                                    fontWeight={(device.isWindows && device.isDesktop) ? '400' : '500'}
                                                    cursor='pointer'
                                                >
                                                    {item.title}
                                                    <IoIosArrowDown 
                                                        style={{marginLeft: '0.7rem'}}
                                                    />
                                                </AppSpan>
                                            </div>
                                        }
                                        options={item?.options}
                                        onSelect={(value: string) => handleMenuOption(value)}
                                        leftMargin={20}
                                        rightMargin={20}
                                    />
                                    :
                                     <NavLink
                                        to={item?.path}
                                        className={({ isActive }) => `default-menu ${isActive && 'active-menu'}`}
                                    >
                                        <AppSpan 
                                            color='#ffffff' textSize='1.6' 
                                            fontWeight={(device.isWindows && device.isDesktop) ? '400' : '500'}
                                            cursor='pointer'
                                        >
                                            {item.title}
                                        </AppSpan>
                                    </NavLink>
                                }
                            </CustomContainer>

                           
                    )
                })
            }
        </FlexRow>
    )
}